import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  statuses: [
    { id: 1, name: 'references.lead_status.1' },
    { id: 2, name: 'references.lead_status.2' },
    { id: 3, name: 'references.lead_status.3' },
    { id: 4, name: 'references.lead_status.4' },
    { id: 5, name: 'references.lead_status.5' },
    { id: 9, name: 'references.lead_status.9' },
    { id: 10, name: 'references.lead_status.10' },
    { id: 11, name: 'references.lead_status.11' },
    { id: 12, name: 'references.lead_status.12' },
    { id: 13, name: 'references.lead_status.13' },
    { id: 14, name: 'references.lead_status.14' },
    { id: 15, name: 'references.lead_status.15'},
    { id: 97, name: 'references.lead_status.97' },
    { id: 98, name: 'references.lead_status.98' },
    { id: 99, name: 'references.lead_status.99' },
    { id: 100, name: 'references.lead_status.100' },
    { id: 101, name: 'references.lead_status.101' },
    { id: 102, name: 'references.lead_status.102' },
    { id: 103, name: 'references.lead_status.103' },
    { id: 104, name: 'references.lead_status.104' },
    { id: 105, name: 'references.lead_status.105' },
    { id: 106, name: 'references.lead_status.106' },
    { id: 107, name: 'references.lead_status.107' },
    { id: 108, name: 'references.lead_status.108' },
    { id: 109, name: 'references.lead_status.109' },
    { id: 110, name: 'references.lead_status.110' },
    { id: 111, name: 'references.lead_status.111' },
    { id: 112, name:'references.lead_status.112'},
    { id: 9997, name: 'references.lead_status.9997' },
    { id: 9998, name: 'references.lead_status.9998' },
    { id: 9999, name: 'references.lead_status.9999' },
    { id: 97, name: 'references.lead_status.97'}
  ]
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
